export default "__VITE_ASSET__iqcy1wAc__"